import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { listNotifications } from '../../api/notifications';

export default function Topbar({ title }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  const refresh = useCallback(() => {
    listNotifications({ unreadOnly: 'true' })
      .then((res) => setUnreadCount(res.unreadCount || 0))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 60000);
    return () => clearInterval(interval);
  }, [refresh]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="topbar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '14px 32px', backgroundColor: '#ffffff', borderBottom: '1px solid #d7d9dd' }}>
      <div className="topbar-actions" style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
        <button type="button" className="btn-link" onClick={() => navigate('/notifications')}>
          Notifications{unreadCount > 0 ? <span className="notification-pill" style={{ marginLeft: 6 }}>{unreadCount}</span> : null}
        </button>
        <button type="button" className="btn btn-secondary btn-small" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}